import { featuredCards } from "@/mocks/gossipData";
import Reveal from "./Reveal";

const toneMap: Record<string, string> = {
  hot: "bg-primary-500 text-background-50",
  first: "bg-accent-500 text-background-50",
  proof: "bg-foreground-950 text-background-50",
  speed: "bg-secondary-500 text-background-50",
  exclusive: "bg-primary-700 text-background-50",
};

export default function FeaturedGrid() {
  return (
    <section id="hot" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" />
                最全黑料 · 今日热瓜
              </p>
              <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-[28px]">
                今日新瓜首发速递抢先看
              </h2>
            </div>
            <a
              href="#hot"
              className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 hover:text-primary-600"
            >
              更多新瓜
              <i className="ri-arrow-right-up-line text-sm" />
            </a>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {featuredCards.map((card, i) => (
            <Reveal key={card.title} delay={i * 80}>
              <a
                href="#hot"
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <div className="relative aspect-[4/5] w-full overflow-hidden">
                  <img
                    src={card.cover}
                    alt={`${card.title}封面图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-black/10" />
                  <span
                    className={`absolute left-3 top-3 flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ${toneMap[card.tone] || toneMap.speed}`}
                  >
                    {card.tone === "hot" && <i className="ri-fire-fill text-[11px]" />}
                    {card.tag}
                  </span>
                  <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-black/40 px-2 py-0.5 text-[11px] font-medium text-white backdrop-blur-sm">
                    <i className="ri-fire-fill text-[11px] text-accent-400" />
                    热度 {card.heat}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-3.5">
                  <h3 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-950">{card.title}</h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">{card.summary}</p>
                  <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-2.5">
                    <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
                      <i className="ri-eye-line text-[11px]" />
                      围观中
                    </span>
                    <span className="flex items-center gap-1 text-[11px] font-medium text-foreground-700">
                      <i className="ri-chat-3-fill text-[11px] text-accent-600" />
                      {card.comments.toLocaleString()}
                    </span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}